export interface User {
  id: number | string,
  username: string,
  name: string,
  login: string,
  role: string | number,
  email: string,
  phone_number: string

  // additional information
  is_staff?: boolean
  is_superuser?: boolean
  is_active?: boolean
  first_name?: string
  last_name?: string
  date_joined?: string
  password?: string
}

export const USER_INIT_STATE: User = {
  id: '',
  username: '',
  name: '',
  email: "",
  login: "",
  phone_number: "",
  role: ""
}

export enum UserRoles {
  ADMIN = 1,
  USER = 2,
  TRAFFIC = 3,
  MODERATOR = 4
}
